import React from "react";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {ValidatedChipInputField} from "../../../../elements/validator/component/ValidatedChipInputField";
import {FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import {MultipleEmailNotEmptyValidator, MultipleEmailValidator} from "../../../../elements/validator/Validator";
import styles from "./TranscriptRoutingTab.module.css";
import {
    addRoutingLocationDepartment,
    RoutingLocation,
    selectRoutingCatchAllRecipients,
    transcriptRoutingDepartmentsSelector,
    transcriptRoutingEnabledSelector,
    TranscriptRoutingSettingsUI,
    updateRoutingLocation
} from "./transcriptRoutingSlice";
import {TranscriptRoutingDepartmentMappingRow} from "./TranscriptRoutingDepartmentMappingRow";
import {fromChipValue, toChipValue} from "./transcriptRoutingUtils";

interface TranscriptRoutingLocationCardProps {
    location: RoutingLocation;
    locationIndex: number;
    formContext: FormContext<TranscriptRoutingSettingsUI>;
}

export const TranscriptRoutingLocationCard: React.FC<TranscriptRoutingLocationCardProps> = ({
    location,
    locationIndex,
    formContext
}) => {
    const dispatch = useAppDispatch();
    const departments = useAppSelector(transcriptRoutingDepartmentsSelector);
    const routingEnabled = useAppSelector(transcriptRoutingEnabledSelector);
    const {updateValidationStatus, getMessage} = formContext;
    const getMessageWrapper = (field: string) => getMessage(field) || "";

    return <div className={styles.locationCard}>
        <h3 className={styles.locationName}>{location.locationName}</h3>
        <ValidatedChipInputField<TranscriptRoutingSettingsUI>
            required={routingEnabled}
            validator={routingEnabled ? MultipleEmailNotEmptyValidator : MultipleEmailValidator}
            selector={state => toChipValue(selectRoutingCatchAllRecipients(locationIndex)(state))}
            fieldName={`locations.${locationIndex}.catchAllRecipients` as keyof TranscriptRoutingSettingsUI}
            onChange={value => dispatch(updateRoutingLocation({
                index: locationIndex,
                patch: {catchAllRecipients: fromChipValue(value)}
            }))}
            updateValidationStatus={updateValidationStatus}
            label="Catch-all recipients"
            placeholder="example@mail.com"
            getMessage={getMessageWrapper}
        />
        <div className={styles.departmentMappings}>
            <div className={styles.departmentHeader}>
                <span className={styles.departmentTitle}>Department recipients</span>
                <button
                    type="button"
                    className={styles.iconActionButton}
                    disabled={departments.length === 0}
                    onClick={() => dispatch(addRoutingLocationDepartment(locationIndex))}
                    aria-label={`Add department recipients for ${location.locationName}`}
                >
                    <img src="/plusIcon.svg" alt=""/>
                </button>
            </div>
            {location.departments.map((_, departmentIndex) =>
                <TranscriptRoutingDepartmentMappingRow
                    key={`${location.locationPublicId}-department-${departmentIndex}`}
                    departments={departments}
                    locationIndex={locationIndex}
                    departmentIndex={departmentIndex}
                    formContext={formContext}
                />
            )}
        </div>
    </div>;
};
